<template>
  <flow-step-empty-base
    name="Freeform Feedback"
    :imgPath="img"
    description="Give customers a chance to give you raw, unfiltered feedback."
    @cta-click="$emit('cta-click')"
  >
    <div>
      Open text feedback enhances the structured feedback you receive from survey questions. After that, our Insights AI gets to work by analyzing
      sentiment and sorting by type. Use it to fuel more product enhancements.
    </div>
  </flow-step-empty-base>
</template>

<script>
import FlowStepEmptyBase from '@/components/FlowSteps/FlowStepEmptyBase.vue';
import img from '@/assets/img/icon-openended.svg';

export default {
  name: 'FlowStepFreeformEmpty',
  components: {
    FlowStepEmptyBase,
  },
  data() {
    return {
      img,
    };
  },
};
</script>
